import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {ExceededModal} from 'entities/user';
import {MonitorsScreen} from 'entities/monitor';
import useHttpMonitors from 'features/http/model/useHttpMonitors';
import {getHttpBatchModalHeader} from 'features/http/lib/httpMonitorFormHelper';

import CreateHttpMonitorButton from '../CreateHttpMonitorButton/CreateHttpMonitorButton';
import HttpMonitorRow from '../HttpMonitorRow/HttpMonitorRow';
import StatHttpMonitorHeader from '../StatHttpMonitorHeader/StatHttpMonitorHeader';
import HttpMonitorFiltersFormHandler from '../HttpMonitorsFilters/HttpMonitorFiltersFormHandler';
import HttpMonitorsExportModal from '../HttpMonitorsExport/HttpMonitorsExportModal';
import HttpMonitorBatchOperationsForm from '../HttpMonitorForm/HttpMonitorBatchOperationsForm';
import HttpMonitorModal from '../HttpMonitorModal';

const HttpMonitors: React.FC = () => {
    const {
        sort,
        pagination,
        summary,
        isLoading,
        isFetching,
        refetch,
        maxMonitors,
        list,
        handleCreate,
        isCreateOpen,
        isExceededOpen,
        closeCreate,
    } = useHttpMonitors();

    return (
        <MonitorsScreen
            documentTitle={t`Мониторинг сайтов | Overseer`}
            title={t`Мониторинг сайтов`}
            count={summary?.total_active}
            maxCount={maxMonitors}
            backUrl={AppUrls.HTTP_MONITORS}
            isFetching={isFetching}
            refetch={refetch}
            searchField="url"
            FiltersFormHandler={HttpMonitorFiltersFormHandler}
            renderExportModal={(state) => <HttpMonitorsExportModal {...state}/>}
            list={list}
            getBatchHeader={getHttpBatchModalHeader}
            renderBatchForm={(props) => <HttpMonitorBatchOperationsForm {...props}/>}
            summary={<StatHttpMonitorHeader items={summary}/>}
            createButton={<CreateHttpMonitorButton onClick={handleCreate} disabled={list.hasSelectedItems}/>}
            createText={t`Добавить сайт`}
            onCreate={handleCreate}
            columns={[
                {label: t`Название / URL`, sort: 'name'},
                {label: t`Доступность`},
                {label: t`Uptime, 24 ч.`, sort: 'availability1'},
                {label: t`Интервал`, sort: 'checkInterval'},
                {label: t`Статус`, sort: 'status'},
                {label: ''},
            ]}
            items={pagination?.items}
            rowFactory={(item) =>
                <HttpMonitorRow
                    key={item.uuid}
                    item={item}
                    hasSelectedItems={list.hasSelectedItems}
                    isMassOperationsMode={list.isMassOperationsMode}
                />
            }
            isLoading={isLoading}
            pagination={pagination}
            sort={sort}
        >
            <HttpMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
                onMonitorCreated={refetch}
            />
            <ExceededModal isOpen={isExceededOpen} handleClose={closeCreate}/>
        </MonitorsScreen>
    );
};

export default HttpMonitors;
